import { LostAndFoundItem } from '@/types/community/lostAndFound';

export const lostAndFoundItems: LostAndFoundItem[] = [
  {
    id: 'item-1',
    title: 'Chave do Apartamento',
    description: 'Chave encontrada no corredor do 1º andar',
    category: 'other',
    status: 'found',
    condition: 'good',
    block: {
      id: 'block-1',
      name: 'Bloco A'
    },
    foundAt: new Date('2024-01-15T09:00:00'),
    handedOverTo: {
      id: 'employee-1',
      name: 'João Silva'
    },
    workspace: {
      id: 'workspace-1',
      name: 'Meu Apartamento',
      slug: 'meu-apartamento'
    }
  },
  {
    id: 'item-2',
    title: 'Relógio de Pulso',
    description: 'Relógio encontrado na área da piscina',
    category: 'jewelry',
    status: 'claimed',
    condition: 'good',
    block: {
      id: 'block-2',
      name: 'Bloco B'
    },
    foundAt: new Date('2024-01-16T14:30:00'),
    claimedBy: {
      id: 'resident-1',
      name: 'Maria Santos',
      type: 'resident'
    },
    returnedAt: new Date('2024-01-17T10:00:00'),
    workspace: {
      id: 'workspace-1',
      name: 'Meu Apartamento',
      slug: 'meu-apartamento'
    }
  },
  {
    id: 'item-3',
    title: 'Documentos Pessoais',
    description: 'Carteira com documentos encontrada no estacionamento',
    category: 'documents',
    status: 'returned',
    condition: 'fair',
    block: {
      id: 'block-1',
      name: 'Bloco A'
    },
    foundAt: new Date('2024-01-18T11:15:00'),
    claimedBy: {
      id: 'resident-2',
      name: 'Carlos Oliveira',
      type: 'resident'
    },
    returnedAt: new Date('2024-01-19T16:00:00'),
    workspace: {
      id: 'workspace-1',
      name: 'Meu Apartamento',
      slug: 'meu-apartamento'
    }
  },
  {
    id: 'item-4',
    title: 'Jaqueta Esportiva',
    description: 'Jaqueta esportiva encontrada na academia',
    category: 'clothing',
    status: 'found',
    condition: 'good',
    block: {
      id: 'block-2',
      name: 'Bloco B'
    },
    foundAt: new Date('2024-01-20T18:45:00'),
    workspace: {
      id: 'workspace-1',
      name: 'Meu Apartamento',
      slug: 'meu-apartamento'
    }
  },
  {
    id: 'item-5',
    title: 'Fone de Ouvido',
    description: 'Fone de ouvido encontrado no elevador',
    category: 'electronics',
    status: 'found',
    condition: 'fair',
    block: {
      id: 'block-1',
      name: 'Bloco A'
    },
    foundAt: new Date('2024-01-21T12:20:00'),
    workspace: {
      id: 'workspace-1',
      name: 'Meu Apartamento',
      slug: 'meu-apartamento'
    }
  }
]; 